import { render } from "./ChatbotWidget.vue?vue&type=template&id=5264aafe&scoped=true"
import script from "./ChatbotWidget.vue?vue&type=script&lang=js"
export * from "./ChatbotWidget.vue?vue&type=script&lang=js"

import "./ChatbotWidget.vue?vue&type=style&index=0&id=5264aafe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5264aafe"]])

export default __exports__